import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import RadioGroup from '@ecp/common/src/components/radio/bo/RadioGroup';
import Button from '@ecp/common/src/components/button/bo/Button';

import FormAccordion from '@bo-components/common/form/FormAccordion';
import FormField from '@bo-components/common/form/FormField';
import Form from '@bo-components/common/form/Form';
import InfoTextBox from '@bo-components/promotion/InfoTextBox';
import CustomerCenterPopup from '../popups/CustomerCenterPopup';
import { RUNNING, TERMINATED } from '../consts/SiteConst';
import CustomerEmailPopup from "@bo-pages/site/popups/CustomerEmailPopup";
import isEmpty from "lodash-es/isEmpty";

const useYnOptions = [
  { value: 'Y', label: '사용' },
  { value: 'N', label: '미사용' },
];
const DetailSiteConfigInfo = ({
  siteBasicInfo,
  welmallCustCenter,
  footerAppDownloadUseYn,
  handleFormChange,
  refreshCustomerCenter,
  disableEdit,
}) => {
  const [showCustomerCenterPopup, setShowCustomerCenterPopup] = useState(false);
  const customCenterInfo = useMemo(
    () =>
      `[${siteBasicInfo.welmallCustomerCenterUseYn === 'Y' ? '웰스토리와 동일' : '직접입력'}]\n` +
      `고객센터 전화번호 : ${siteBasicInfo.customerCenterTel}\n` +
      `운영 시간 : 평일 ${siteBasicInfo.customerCenterOperatingStartHh} ~ ${siteBasicInfo.customerCenterOperatingEndHh}\n` +
      `점심시간 ${siteBasicInfo.customerCenterLunchStartHh} ~ ${siteBasicInfo.customerCenterLunchEndHh}\n` +
      `${siteBasicInfo.customerCenterGuide}`,
    [siteBasicInfo]
  );
  const [showCustomerEmailPopup, setShowCustomerEmailPopup] = useState(false);

  return (
    <>
      <FormAccordion
        label={'사이트구성정보'}
        initialOpen
        buttonless
        description={'사이트 구성정보를 관리합니다.'}
        noFold
      >
        <Form>
          <FormField label={'Footer APP 다운로드'}>
            <FlexBoxColumn>
              <RadioGroup
                value={footerAppDownloadUseYn}
                itemList={useYnOptions}
                onClick={handleFormChange}
                data-key="footerAppDownloadUseYn"
                disabled={[RUNNING, TERMINATED].includes(siteBasicInfo.siteStatCode) || disableEdit}
              />
              <Spacing bottom={10} />
              <InfoTextBox>
                사용을 하면 Footer에서 APP 다운로드 버튼이 보여지고, APP 다운로드 링크로 연결됩니다.
              </InfoTextBox>
            </FlexBoxColumn>
          </FormField>
          <FormField label={'고객센터'}>
            <TextBox style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{customCenterInfo}</TextBox>
            <Spacing margin={'auto'} />
            <Button
              type={'Third'}
              width={'94px'}
              minWidth={'94px'}
              onClick={() => setShowCustomerCenterPopup(true)}
              disabled={siteBasicInfo.siteStatCode === TERMINATED}
            >
              고객센터수정
            </Button>
          </FormField>
          <FormField label={'대표 메일'} full>
            <TextBox style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
              { !isEmpty(siteBasicInfo.resdEmail) ? (
                siteBasicInfo.resdEmail
              ) : (
                welmallCustCenter.resdEmail
              )}
            </TextBox>
            <Spacing margin={'auto'} />
            <Button
              type={'Third'}
              width={'94px'}
              minWidth={'94px'}
              onClick={() => setShowCustomerEmailPopup(true)}
              disabled={siteBasicInfo.siteStatCode === TERMINATED}
            >
              대표메일수정
            </Button>
          </FormField>
        </Form>
      </FormAccordion>
      <CustomerCenterPopup
        open={showCustomerCenterPopup}
        onClose={() => setShowCustomerCenterPopup(false)}
        siteBasicInfo={siteBasicInfo}
        welmallCustCenter={welmallCustCenter}
        refreshCustomerCenter={refreshCustomerCenter}
      />
      <CustomerEmailPopup
        open={showCustomerEmailPopup}
        onClose={() => setShowCustomerEmailPopup(false)}
        siteBasicInfo={siteBasicInfo}
        welmallCustCenter={welmallCustCenter}
        welmallCustCenterEmail={siteBasicInfo.customerCenterTel}
        refreshResdEmail={refreshCustomerCenter}
      />
    </>
  );
};

export default DetailSiteConfigInfo;

DetailSiteConfigInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
  welmallCustCenter: PropTypes.object,
  setShowCustomerCenterPopup: PropTypes.func,
  footerAppDownloadUseYn: PropTypes.string,
  handleFormChange: PropTypes.func,
  refreshCustomerCenter: PropTypes.func,
  disableEdit: PropTypes.bool,
};
